export default __webpack_public_path__ + "images/0b71edc5f46fa1b734678d4336f4f463.jpg";